module.exports = __webpack_public_path__ + "static/Advantage03@1x.d42d3e7b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/events/new/Advantage03@1x.png
// module id = 689
// module chunks = 216210090109534